<template>
  <div :id="orderId" class="cart-item d-flex justify-content-between border-bottom p-2">
    <div class="cart-item-left mr-3 flex-grow-1">
      <h3 class="mb-0">
        <slot name="productName"></slot>
      </h3>
      <p class="mb-0">
        <slot name="productAttributes"></slot>
      </p>
      <p class="mb-0">
        <slot name="productAddOns"></slot>
      </p>
    </div>
    <div class="cart-item-right flex-shrink-0 d-inline-flex flex-column align-items-end">
      <div class="item-quantity d-flex align-items-center">
        <b-button
          :id="`${orderId}-minus`"
          class="item-quantity-btn mr-2 p-0 rounded-circle d-inline-flex align-items-center justify-content-center"
          :disabled="loading.cart_quantity"
          @click="updateQuantity('subtract')">
          -
        </b-button>
        <span class="form-control mx-2 border-0 text-center quantity-count">
          <slot name="productQty"></slot>
        </span>
        <b-button
          :id="`${orderId}-plus`"
          class="item-quantity-btn ml-2 p-0 rounded-circle d-inline-flex align-items-center justify-content-center"
          :disabled="loading.cart_quantity || isAddButtonDisabled"
          @click="updateQuantity('plus')">
          +
        </b-button>
      </div>
      <div class="item-price text-right mt-2">
        <slot name="productPrice"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import _ from "lodash";

export default {
  props: ['orderId', 'itemUuid', 'branchUuid'],
  computed: {
    ...mapGetters({
      cartItems: "conversationalCommerce/cartItems",
      loading: "conversationalCommerce/loading"
    }),
    item: {
      get() {
        if (this.cartItems.list.length > 0) return this.cartItems.list
          .find(branch => branch.branch_uuid === this.branchUuid).items
          .find(item => item.uuid === this.itemUuid);
      },
      set(item) {
        return item;
      }
    },
    isAddButtonDisabled: {
      get() {
        if (this.item) return this.item.product_inventory.is_limited_stock
          ? Number(this.item.quantity) >= this.item.product_inventory.stock
          : false;
      },
      set(status) {
        return status;
      }
    }
  },
  methods: {
    updateQuantity(method) {
      if (this.cartItems.list.find(branch => branch.branch_uuid === this.branchUuid).items.length > 0) {
        this.$store.commit("conversationalCommerce/setCartItemQty", { method: method, item: this.itemUuid, branch: this.branchUuid });
        this.$nextTick(async () => {
          if (
            this.cartItems.list
            .find(branch => branch.branch_uuid === this.branchUuid).items
            .find(item => item.uuid === this.itemUuid).quantity <= 0
          ) {
            await this.$store.dispatch("conversationalCommerce/removeCartItem", this.itemUuid);
          }
          else await this.$store.dispatch("conversationalCommerce/updateCart", { item: this.itemUuid, branch: this.branchUuid, quantity: method === 'plus' ? 1 : -1 });

          this.$parent.computeCartItemWidths();
        });
      };
    }
  }
}
</script>

<style lang="scss" scoped>
.cart-item {
  h3 {
    font-size: 16px;
    color: #2F3941;
    word-break: break-all;
  }
  p {
    font-size: 14px;
    color: #68737D;
  }
  .cart-item-right {
    .item-quantity {
      .form-control {
        width: fit-content;
        background: #E9EBED;
        border-radius: 10px;
        font-size: 14px;
      }
      .item-quantity-btn {
        width: 20px;
        height: 20px;
        background: #2F3941;
      }
    }
  }
  .item-price {
    font-size: 16px;
    color: #2F3941;
  }
}
</style>
